import React, { useMemo } from 'react';
import './HeroSection.css';

const HeroSection = () => {
  const title = "ANGRY ALIEN ALLIANCE!";

  const alienConfigs = useMemo(() => [
    { src: require('../images/alien1.webp'), alt: 'Alien 1', className: 'alien-1', delay: 0.1 },
    { src: require('../images/alien2.webp'), alt: 'Alien 2', className: 'alien-2', delay: 0.2 },
    { src: require('../images/alien3.webp'), alt: 'Alien 3', className: 'alien-3', delay: 0.3 },
    { src: require('../images/alien4.webp'), alt: 'Alien 4', className: 'alien-4', delay: 0.2 },
    { src: require('../images/alien5.webp'), alt: 'Alien 5', className: 'alien-5', delay: 0.1 }
  ], []);

  return (
    <div className="hero-wrapper">
      <section className="hero-section">
        <h1 className="hero-title">
          {title.split(' ').map((word, wIdx) => (
            <span key={wIdx} className="word">
              {word.split('').map((char, cIdx) => (
                <span
                  key={cIdx}
                  className="letter"
                  style={{ animationDelay: `${cIdx * 0.05}s` }}
                >
                  {char}
                </span>
              ))}
              &nbsp;
            </span>
          ))}
        </h1>

        <div className="aliens-container">
          {alienConfigs.map((alien, idx) => (
            <img
              key={idx}
              src={alien.src}
              alt={alien.alt}
              className={`alien ${alien.className}`}
              style={{ animationDelay: `${alien.delay}s` }}
              loading="eager"
            />
          ))}
        </div>
      </section>
    </div>
  );
};

export default HeroSection;